import React from 'react';
import { Link } from 'gatsby';
//import { IconHour, IconUser } from '../../components/Icons';
import classnames from 'classnames';

import './TutorialPage.scss';
import { PageProps } from '../../entities/ContentProps';

export default function Page({ className, children }: PageProps) {
  return (
    <div className={classnames('page-link', className)}>
      <Link to={children.node.fields.slug}>
        <div className="page-link__box">
          <div className={classnames('page-link__info', { 'page-link__info--only-date': !children.node.childMdx.frontmatter.difficulty })}>
            {children.node.childMdx.frontmatter.difficulty && (
              <span
                className={classnames('page-link__label', {
                  'page-link__label--advanced': children.node.childMdx.frontmatter.difficulty === 'advanced',
                  'page-link__label--intermediate': children.node.childMdx.frontmatter.difficulty === 'intermediate',
                })}
              >
                {children.node.childMdx.frontmatter.difficulty}
              </span>
            )}
            {/* <div className="page-link__info--meta">
              <span className="page-link__user">
                <IconUser />
                {children.node.childMdx.frontmatter.author}
              </span>
              {children.node.fields.gitLogLatestDate && (
                <span className={'page-link__date'}>
                  <IconHour />
                  {new Date(children.node.fields.gitLogLatestDate.slice(0, 19).replace(/\s+/g, 'T')).toLocaleString([], {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                  })}
                </span>
              )}
            </div> */}
          </div>
          <h4>{children.node.childMdx.frontmatter.title}</h4>
          <p>{children.node.childMdx.frontmatter.description}</p>
        </div>
      </Link>
      {/* {children.node.childMdx.frontmatter.tags?.length > 0 && (
        <div className='page-link__tags'>
          {children.node.childMdx.frontmatter.tags?.map((tag) => {
            return (
              <div key={tag} className="page-link__tags--item">
                {tag}
              </div>
            );
          })}
        </div>
      )} */}
    </div>
  );
}
